export default __webpack_public_path__ + "static/media/photo--sm--kara6.4b93181c.jpg";